<template lang="html">
  <div class="card" :style="{ 'background-image': 'url(' + imageURL + ')' }">
    <router-link :to="getFormattedLink()" class="link-card">
      <div class="content">
        <h4 class="title">{{ title }}</h4>
        <p class="description">{{ description }}</p>
      </div>
    </router-link>
    <div class="cortina"></div>
  </div>
</template>
<script>
export default {
  props: {
    id: Number,
    imageURL: String,
    title: String,
    description: String,
    router: String,
  },
  methods: {
    escapeQuestionMark(text) {
      return text.replace(/\?/g, '%3F');
    },

    getFormattedLink() {
      const escapedTitle = this.escapeQuestionMark(this.title);
      return `/categoria/${this.router}/${escapedTitle}?id=${this.id}`;
    },
  },
};
</script>
<style lang="css" scoped>
.card {
  background-repeat: no-repeat;
  background-size: cover;
  width: 310px;
  height: 162px;
  border: none;
  cursor: pointer;
  transition: all 0.5s;
  border-radius: 10px;
  margin: 0 2px;
}
.card:hover {
  transition: all 0.5s;
  width: 390px !important;
  height: 210px;
  overflow: hidden;
  box-shadow: 1px 1px 20px 0 #002e46cc;
  z-index: 5;
}

.card:hover::before .content {
  padding: 18px;
}
.card:hover .content .title {
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 10px;
}
.card:hover .content .description {
  height: auto;
  overflow: initial;
  opacity: 1;
  font-size: 16px;
  line-height: 21px;
}
.card .content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 12px;
  position: relative;
  z-index: 2;
}
.card .content .title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
  margin-bottom: 0;
  text-align: left;
}
.card .content .description {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  color: #ffffff;
  text-align: left;
  height: 0;
  overflow: hidden;
  margin-bottom: 0;
  opacity: 0;
  transition: all 0.6s ease-in-out;
}
.card .cortina {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  transition: all 0.5s;
}
.link-card {
  width: 100%;
  height: 100%;
}
</style>
